var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.042,
    height: 18.725,
    viewBox: "0 0 23.042 18.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_03-twitter_104501",
    d: "M26.616,12.543a9.406,9.406,0,0,1-2.715.744,4.736,4.736,0,0,0,2.079-2.616,9.463,9.463,0,0,1-3,1.148,4.731,4.731,0,0,0-8.055,4.312,13.423,13.423,0,0,1-9.744-4.939A4.733,4.733,0,0,0,6.641,17.5,4.714,4.714,0,0,1,4.5,16.911c0,.02,0,.04,0,.06a4.731,4.731,0,0,0,3.792,4.635,4.753,4.753,0,0,1-1.246.166,4.684,4.684,0,0,1-.89-.085,4.733,4.733,0,0,0,4.416,3.283,9.539,9.539,0,0,1-7,1.957A13.444,13.444,0,0,0,24.271,15.6q0-.307-.013-.612A9.575,9.575,0,0,0,26.616,12.543Z",
    transform: "translate(-3.574 -10.326)",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.84b01c18e4855169935b5cce38dae814.svg";
export { ForwardRef as ReactComponent };